export const applyCouponCode = {
  APPLY_COUPON_CODE_REQUEST: "APPLY_COUPON_CODE_REQUEST",
  APPLY_COUPON_CODE_SUCCESS: "APPLY_COUPON_CODE_SUCCESS",
  APPLY_COUPON_CODE_ERROR: "APPLY_COUPON_CODE_ERROR",
};
